import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import echarts from 'echarts'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { MMS3D_newCanvas, MMS3D_API } from '../public/MMS3D/enter.js';

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.MMS3D_newCanvas = MMS3D_newCanvas
Vue.prototype.MMS3D_API = MMS3D_API
Vue.prototype.$echarts = echarts

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
